'use client';

import type { FC } from 'react';
import { BaseLineActivity } from '@/app/components/icons/BaseLineActivity';
import { BaseLineRight } from '@/app/components/icons/BaseLineRight';
import { ActivityStatus } from '@/app/components/shared/Activity/ActivityStatus';
import { AwardBadge } from '@/app/components/shared/Activity/Award';
import type { Activity } from '@/app/types';
import { cn } from '@/app/utils';
import { Link } from '@/i18n/routing';
import type { ViduV1WorkAward } from '../types';

interface ActivityInfoProps {
  activity?: Activity;
  award?: ViduV1WorkAward;
  className?: string;
}

/**
 * 活动投稿的信息
 * 包括：活动名称、活动状态、奖项
 */
export const ActivityInfo: FC<ActivityInfoProps> = ({ activity, award, className }) => {
  if (!activity) return null;

  return (
    <div className={cn('flex flex-wrap items-center gap-2 text-system-white/70', className)}>
      <BaseLineActivity className="text-sm" />
      <Link
        href={`/activity/${activity.id}`}
        className="flex items-center text-xs hover:text-system-white"
        prefetch={false}
      >
        {activity.title}
        <BaseLineRight className="text-sm" />
      </Link>
      <ActivityStatus status={activity.phase} className="h-5 px-1" />
      {activity.phase !== 'in_evaluation' && (
        <AwardBadge award={award} className="flex items-center gap-1" itemClassName="h-5 bg-system-white10" />
      )}
    </div>
  );
};
